export default {
	title: '戦略計画',
	tabs: {
		general: {
			title: '一般'
		},
		filters: {
			title: '表示フィルター'
		},
		bot: {
			title: 'AI'
		},
		export: {
			title: 'エクスポート'
		},
		display: {
			title: '表示'
		}
	},
	filters: {
		responsible: {
			title: '担当者で絞り込み',
			placeholder: '担当者名'
		},
		completion: {
			title: '進捗で絞り込み',
			not_started: '未着手',
			in_progress: '進行中',
			completed: '完了'
		},
		dates: {
			title: '日付で絞り込み'
		},
		startOn: {
			title: '開始日で絞り込み',
			undefined: '日付なし',
			past: '過去',
			ending_week: '1週間以内に開始',
			ending_month: '1か月以内に開始',
			ending_quarter: '四半期以内に開始',
			ending_year: '1年以内に開始'
		},
		endOn: {
			title: '終了日で絞り込み',
			undefined: '日付なし',
			done: '完了',
			overdue: '期限超過',
			ending_week: '1週間以内に終了',
			ending_month: '1か月以内に終了',
			ending_quarter: '四半期以内に終了',
			ending_year: '1年以内に終了'
		}
	},

	display: {
		sort: {
			title: '枝の並び順',
			startOn: '開始日順',
			name: '名前順',
			manual: '手動の並び順'
		}
	},
	all_icons: 'アイコンで絞り込み',
	no_icon: 'アイコンなし',
	onboarding: {
		title: 'アクションプランのレビュー',
		description:
			'軸と項目があなたのプランの理解と一致しているか確認してください。'
	}
};
